// src/components/KpiCards.jsx
import React from 'react';
import { wholeUnits } from './utils/formatters';

export default function KpiCards({
  selectedDate,
  summary,
  hasRows,
  fullUSD,
  totalNotionalIsCommodity,
}) {
  // Reuse the same date formatting logic that ChartTooltip applies
  const dateText = (() => {
    if (!selectedDate) return '—';
    // ChartTooltip’s internal logic: ISO if numeric, fallback to string
    const d = new Date(selectedDate);
    if (!Number.isNaN(d.getTime())) {
      return d.toISOString().slice(0, 10); // yyyy-mm-dd
    }
    return String(selectedDate);
  })();

  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-4 min-w-0">
      <div className="bg-card border border-border shadow rounded p-4">
        <div className="text-muted-foreground text-sm">Total Value ({dateText})</div>
        <div className="text-xl font-bold">
          {hasRows ? fullUSD(summary.totalVal) : '–'}
        </div>
      </div>
      <div className="bg-card border border-border shadow rounded p-4">
        <div className="text-muted-foreground text-sm">Total Notional ({dateText})</div>
        <div className="text-xl font-bold">
          {hasRows
            ? totalNotionalIsCommodity
              ? wholeUnits(summary.totalNotional)
              : fullUSD(summary.totalNotional)
            : '–'}
        </div>
      </div>
      <div className="bg-card border border-border shadow rounded p-4">
        <div className="text-muted-foreground text-sm">Total PV01 ({dateText})</div>
        <div className="text-xl font-bold">
          {hasRows ? fullUSD(summary.totalPv01) : '–'}
        </div>
      </div>
    </div>
  );
}
